export enum CPLinkType {
    Web = "Web",
    Video = "Video",
    Audio = "Audio"
}